import { getBaseDataURL } from "../../../common";
import { BaseDataModel } from "@domain/BaseDataModel";
import { CreateAPI_Base } from "./create";
import { GetAPI_Base, ModelConstructor } from "./get";
import { UpdateAPI_Base } from "./update";

export class DataAPI_Base<T extends BaseDataModel> {
	private router: string;
	protected baseUrl: string;
	public create: CreateAPI_Base<T>;
	public get: GetAPI_Base<T>;
	public update: UpdateAPI_Base<T>;

	constructor(router: string, ModelClass: ModelConstructor<T>, isCompressed: boolean = false) {
		this.router = router;
		this.baseUrl = getBaseDataURL(router);
		this.create = new CreateAPI_Base<T>(this.router);
		this.get = new GetAPI_Base<T>(this.router, ModelClass, isCompressed);
		this.update = new UpdateAPI_Base<T>(this.router);
	}
}

export * from "./create";
export * from "./get";
export * from "./update";
